import type { PropsWithChildren, ReactNode } from 'react'
import styled from 'styled-components'
import { colors, fontSize } from '@capture/client/assets/styleConstants'
import { FullscreenOverlay } from '@capture/client/components/Common/FullscreenOverlay'
import { RippleLoaderOverlay } from '@capture/client/components/Common/RippleLoaderOverlay'

const Wrapper = styled.div`
    position: relative;
    max-width: 400px;
    background-color: white;
    box-shadow: 0px 2px 13px 0px rgba(0, 0, 0, 0.2);
    padding: 24px;
    box-sizing: border-box;
    border-radius: 3px;
    font-size: ${fontSize.medium_18};
    margin: 0 4px;
`

const Title = styled.h3`
    font-weight: 700;
    font-size: ${fontSize.medium_20};
    margin: 0;
`

const ButtonsWrapper = styled.div`
    display: flex;
    gap: 16px;
    width: 100%;
    justify-content: flex-end;
    border-top: 1px solid ${colors.captureGrey300};
    padding-top: 16px;

    & > div {
        flex: 1;
        max-width: 144px;
    }
    & > :last-child {
        flex: 0 1 144px;
    }
`

interface ComposableDialogBoxProps {
    header: string
    ButtonComponents: ReactNode
    loading?: boolean
    cyKey: string
}

// a composable version of DialogPromptComponent
const ComposableDialogBox = (
    props: PropsWithChildren<ComposableDialogBoxProps>,
) => {
    return (
        <FullscreenOverlay>
            <Wrapper data-cy={props.cyKey}>
                {props.loading && <RippleLoaderOverlay />}
                <Title>{props.header}</Title>
                {props.children}
                <ButtonsWrapper>{props.ButtonComponents}</ButtonsWrapper>
            </Wrapper>
        </FullscreenOverlay>
    )
}

export default ComposableDialogBox
